import getAgentBankAccounts from '../../controllers/Bank/getAgentBankAccounts'
import { useSelector } from 'react-redux'
import requestWalletPayout from '../../controllers/settings/wallet/requestWalletPayout';

export default function usePayment() {
    const {userData: {agent}} = useSelector(state => state.user)

    async function getAgentBanks() {
        let data = [];
        const res = await getAgentBankAccounts(agent?._id)
        if(res?.return) {
            data = res?.data?.data;
        }
        return data;
    }

    async function requestWalletWithdraw(data) {
      const res = await requestWalletPayout(data);
      return res;
    }
    
  return {
    getAgentBanks,
    requestWalletWithdraw,
  }
}
